<template>
    <v-container class="app-page-container">
        <div v-if="getStudentGroupsChanged">{{ changeGroups() }}</div>
        <div v-if="getEssayReviewChanged">{{ changeReview() }}</div>


        <GroupList :course_id="$route.params.course_id" />
        <div v-if="!prepared"> ... reading ... </div>
        <div v-if="prepared">
            <v-card >
                <div style="margin: 4px;cursor:pointer" @click="showAssignment = !showAssignment">
                    <h4><v-icon variant="large">{{ myIcon }}</v-icon> &nbsp;&nbsp; Assignment (max. score: {{ taskInfo.max_score }})</h4>
                    <v-icon v-if="showAssignment" class="btn-close" >expand_more</v-icon>
                    <v-icon v-if="!showAssignment" class="btn-close" >expand_less</v-icon>
                </div>
                <v-card-text style="margin:5px" v-if="showAssignment">
                    <TTask2_10 :myContent="taskInfo" v-if="taskInfo.task_type_id >=2 && taskInfo.task_type_id <=10"/>
                    </v-card-text>
            </v-card>
            <div class="table-container" >
                <table class="my-table">
                    <thead>
                    <tr>
                        <th >Name</th><th >Surname</th><th>Attempts</th><th >Detail</th>
                    </tr>
                    </thead>
                    <!-- Render data rows -->
                    <tbody>
                    <tr v-for="(rowdata, rowIndex) in myStudents" :key="rowIndex" valign="top">
                        <td>{{rowdata.name}}</td><td>{{rowdata.surname}}</td>
                        <td style="width:15%"> 
                            <div class="course-additional-activities background-transparent shadow-none">
                                <div style="margin: 4px;cursor:pointer"  @click="changeListAttempts(rowIndex)">
                                    <v-btn class="background-transparent" style="width:100%" v-if="rowdata.attempts.length > 0">
                                        {{rowdata.score}} / {{taskInfo.max_score}} - attempts: {{rowdata.attempts.length}}
                                        <v-spacer />
                                        <v-icon v-if="openedAttempts.indexOf(rowIndex) > -1">expand_less</v-icon>
                                        <v-icon v-else >expand_more</v-icon>
                                    </v-btn>
                                    <v-btn class="background-transparent" style="width:100%" v-if="rowdata.attempts.length == 0">
                                        0
                                    </v-btn>
                                </div>
                                <ul v-if = "openedAttempts.indexOf(rowIndex) > -1 && rowdata.attempts.length > 0">
                                    <li class="background-transparent" style="width:100%;cursor:pointer" v-for="(attempt, index) in rowdata.attempts" :key="index" @click="myStudents[rowIndex].active = index">
                                        <b v-if="rowdata.active == index"> {{ attempt.time_stamp}} ({{ attempt.time_length}} s) - {{ attempt.score}} </b>
                                        <span v-if="rowdata.active != index"> {{ attempt.time_stamp}} ({{ attempt.time_length}} s) - {{ attempt.score}} </span>                                        
                                    </li>

                                </ul>
                            </div>
                        </td>
                        <td class="course-additional-activities background-transparent shadow-none" style="width:100%">
                            <div v-if="rowdata.attempts.length != 0">
                            <TAnswerDecoder  
                                        :task_type_id="taskInfo.task_type_id" 
                                        :myAnswers="JSON.parse(rowdata.attempts[rowdata.active].answers)" 
                                        :myInfo="rowdata.attempts[rowdata.active].info" 
                                        :maxScore="rowdata.attempts[rowdata.active].max_score" 
                                        :curScore="rowdata.attempts[rowdata.active].score" 
                                        :attID="rowdata.attempts[rowdata.active].id" />
                                        {{ rowdata.attempts[rowdata.active].info }}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </v-container>
</template>

<script>
 import axios from '../axios-auth'
 import { mapGetters } from 'vuex'
 import GroupList from '../components/data/group_list.vue'
 import TTask2_10 from '../elements/teacher_tasks/ttask_2_10.vue'
 import TAnswerDecoder from '../elements/answer_decoder/answer_decoder.vue'


 import * as icn from '../assets/task_icons.js'

export default {
    data() {
        return {
            students: [],
            taskInfo: [],
            headers: [],
            myStudents: [],
            groups_ids: [],
            prepared: false,
            showAssignment: true,
            myIcon: '',
            openedAttempts: []
        }
    },
    computed:
        mapGetters([
            'isDarkMode',
            'getStudentGroupsChanged',
            'getEssayReviewChanged'
        ])
    ,    
    components: {
        GroupList,
        TTask2_10,
        TAnswerDecoder
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {            
            // all students lessons
            let _data = {
                course_id: this.$route.params.course_id,
                chapter_id: this.$route.params.chapter_id,
                lesson_id: this.$route.params.lesson_id,
                task_id: this.$route.params.task_id
            }
            axios.post('/get-students-groups-task-detail', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    console.log(res.data)
                    // this.tasks = res.data.tasks
                    this.students = res.data.students
                    this.taskInfo = res.data.task
                    this.myIcon = icn.getTaskIcon(this.taskInfo.task_type_id),
                    this.refreshGroups()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        changeGroups() {            
            this.$store.commit('setStudentGroupsChanged', false)
            const _localg = localStorage.getItem('student_groups')
            if (_localg) this.groups_ids = JSON.parse(_localg)
                else this.groups_ids = []            
            this.refreshGroups()
        },
        refreshGroups() {
            this.prepared = false
            this.myStudents = []
            for (let i = 0; i < this.students.length; i++) {
                if (this.groups_ids.indexOf(this.students[i].group_id) > -1) {
                   var tmp = this.students[i]
                   this.myStudents.push(tmp)
                }
            }
            this.prepared = true         
        },
        changeListAttempts(_rowIndex) {
            if (this.openedAttempts.indexOf(_rowIndex) > -1) {
                const _index = this.openedAttempts.indexOf(_rowIndex)
                if (_index !== -1) this.openedAttempts.splice(_index, 1)
            } else {
                this.openedAttempts.push(_rowIndex)
            }
        },
        changeReview() {     
            // write to db     
            this.$store.commit('setEssayReviewChanged', false)
            const _data = {
                attempt_id: this.$store.getters.getEssayReviewData.attempt_id,
                score: this.$store.getters.getEssayReviewData.score,
                comment: this.$store.getters.getEssayReviewData.comment,
                course_id: this.$route.params.course_id,
                task_id: this.$route.params.task_id
            }
                
            console.log(_data)
            axios.post('/save-essay-comment-to-attempt', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    if (res.data.message != 'OK') {
                        this.feedback = res.data.message
                    } else {
                        console.log(res.data)
                        for (let i = 0; i < this.students.length; i++) {
                            for(let j = 0; j < this.students[i].attempts.length; j++) {                    
                                if (this.students[i].attempts[j].id == _data.attempt_id) {
                                    const _temp = {
                                        answers: this.students[i].attempts[j].answers,
                                        id: _data.attempt_id,
                                        info: _data.comment,
                                        max_score: this.students[i].attempts[j].max_score,
                                        score: _data.score,
                                        time_length: this.students[i].attempts[j].time_length,
                                        time_stamp: this.students[i].attempts[j].time_stamp
                                    }
                                    this.students[i].attempts.splice(j,1)
                                    this.students[i].attempts.splice(j,0,_temp)
                                    return
                                }                    
                            }
                        }
                    }

                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 

        }
    }
}
</script>
